import React from "react";
import { OverlayTrigger, LinkToNode, Spinner } from "components/common";
import { Label } from "components/bootstrap";
import InputStateComparator from "logic/inputs/InputStateComparator";
import { NodesStore } from "stores/nodes/NodesStore";
import { useStore } from "stores/connect";
const comparator = new InputStateComparator();
const getLabelClassForState = (sortedStates, input, nodes) => {
  const nodesWithKnownState = sortedStates.reduce((numberOfNodes, state2) => numberOfNodes + state2.count, 0);
  if (input.global && nodesWithKnownState !== Object.keys(nodes).length) {
    return "warning";
  }
  const { state } = sortedStates[0];
  switch (state) {
    case "RUNNING":
      return "success";
    case "FAILED":
    case "STOPPED":
      return "danger";
    case "STARTING":
      return "info";
    default:
      return "warning";
  }
};
const getTextForState = (sortedStates, input) => input.global ? sortedStates.map((state) => `${state.count} ${state.state}`).join(", ") : sortedStates[0].state;
const InputStateBadge = ({ input, inputStates = void 0 }) => {
  const { nodes } = useStore(NodesStore);
  const isLoading = !(inputStates && nodes);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const inputId = input.id;
  const sortedInputStates = {};
  if (inputStates[inputId]) {
    Object.keys(inputStates[inputId]).forEach((node) => {
      const { state } = inputStates[inputId][node];
      if (!sortedInputStates[state]) {
        sortedInputStates[state] = [];
      }
      sortedInputStates[state].push(node);
    });
  }
  const sorted = Object.keys(sortedInputStates).sort(comparator.compare.bind(comparator)).map((state) => ({
    state,
    count: sortedInputStates[state].length
  }));
  if (sorted.length > 0) {
    const popOverText = sorted.map(
      (state) => sortedInputStates[state.state].map((node) => /* @__PURE__ */ React.createElement("small", { key: `${input.id}-state-${state.state}-node-${node}` }, /* @__PURE__ */ React.createElement(LinkToNode, { nodeId: node }), ": ", state.state, /* @__PURE__ */ React.createElement("br", null)))
    );
    return /* @__PURE__ */ React.createElement(
      OverlayTrigger,
      {
        trigger: "hover",
        placement: "bottom",
        overlay: popOverText,
        rootClose: true,
        title: `Input States for ${input.title}`
      },
      /* @__PURE__ */ React.createElement(Label, { bsStyle: getLabelClassForState(sorted, input, nodes), bsSize: "xsmall", style: { cursor: "pointer" } }, getTextForState(sorted, input))
    );
  }
  const text = input.global || input.node === void 0 ? "0 RUNNING" : "NOT RUNNING";
  return /* @__PURE__ */ React.createElement(Label, { bsStyle: "warning", bsSize: "xsmall" }, text);
};
export default InputStateBadge;
